/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Spinner, Alert } from "react-bootstrap";
import api from "../../utils/api";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Random = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [questionIds, setQuestionIds] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [levels, setLevels] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [templateSubjectIds, setTemplateSubjectIds] = useState([]);
  const [replacingId, setReplacingId] = useState(null);

useEffect(() => {
  const init = async () => {
    const ids = await fetchTemplateDetails();
    await fetchSubjects(ids);
    fetchLevel();
  };
  init();
}, []);

  useEffect(() => {
    if (selectedSubject.length > 0) {
      fetchChapters(selectedSubject);
    } else {
      setChapters([]);
      setSelectedChapter([]);
      setTopics([]);
      setSelectedTopic([]);
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (selectedSubject.length > 0 && selectedChapter.length > 0) {
      fetchTopics(selectedSubject, selectedChapter);
    } else {
      setTopics([]);
      setSelectedTopic([]);
    }
  }, [selectedSubject, selectedChapter]);

  async function fetchTemplateDetails() {
  const loggedInUser = localStorage.getItem("loggedInUser");
  const token = localStorage.getItem("authToken");

  const fd = new FormData();
  fd.append("programType", "getTemplateDetailsInAddQuestions");
  fd.append("loggedInUser", loggedInUser);
  fd.append("token", token);
  fd.append("id", id);

  try {
    const response = await api.post("paper/paperCurl", fd);
    const templateDetails = response.data?.data?.[0]?.details;

    if (templateDetails) {
      const parsed = JSON.parse(templateDetails);
      const sections = parsed.sections;

      const subjectIdSet = new Set();

      Object.values(sections).forEach((section) => {
        Object.values(section.subjects).forEach((subj) => {
          subjectIdSet.add(Number(subj.subjectId));
        });
      });

      const ids = Array.from(subjectIdSet);
      setTemplateSubjectIds(ids);
      return ids;
    }
  } catch (error) {
    console.error("Error fetching template details:", error);
  }

  return [];
}

async function fetchSubjects(templateSubjectIds = []) {
  try {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role");

    const fd = new FormData();
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("programType", "getSubjectOnChange");
    fd.append("role", role);

    const subjectResponse = await api.post("onchange/onchangeCurl", fd);

    const fetchedSubjects = Array.isArray(subjectResponse.data.data)
      ? subjectResponse.data.data
      : [];

    // ✅ FILTER HERE
    const filteredSubjects = fetchedSubjects.filter((subject) =>
      templateSubjectIds.includes(Number(subject.id))
    );

    setSubjects(filteredSubjects);

  } catch (error) {
    console.error("Error fetching subjects:", error);
    setSubjects([]);
  }
}

  async function fetchChapters(subjectIds) {
    if (!subjectIds || subjectIds.length === 0) {
      setChapters([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getChapterOnChangeMultiple";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      subjectIds.forEach((subjectId, index) => {
        fd.append(`subjectId[${index}]`, subjectId);
      });

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(chapterResponse.data.data)) {
        setChapters(chapterResponse.data.data);
      } else {
        setChapters([]);
      }
    } catch (error) {
      setChapters([]);
    }
  }

  async function fetchTopics(subjectIds, chapterIds) {
    if (
      !subjectIds ||
      subjectIds.length === 0 ||
      !chapterIds ||
      chapterIds.length === 0
    ) {
      setTopics([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChangeMultiple";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      subjectIds.forEach((subjectId, index) => {
        fd.append(`subjectId[${index}]`, subjectId);
      });

      chapterIds.forEach((chapterId, index) => {
        fd.append(`chapterId[${index}]`, chapterId);
      });

      const topicResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(topicResponse.data.data)) {
        setTopics(topicResponse.data.data);
      } else {
        setTopics([]);
      }
    } catch (error) {
      setTopics([]);
    }
  }

  async function fetchLevel() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getLevelDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("level/levelCurl", fd);
      if (Array.isArray(response.data.getLevelDetails)) {
        setLevels(response.data.getLevelDetails);
      } else {
        setLevels([]);
      }
    } catch (error) {
      console.error("Error fetching levels:", error);
      setLevels([]);
    }
  }

  async function fetchRandomQuestions() {
    if (!selectedSubject.length || !selectedChapter.length || !selectedTopic.length) {
      toast.warning("Please select Subject, Chapter, and Topic before generating questions.");
      return;
    }

    setIsGenerating(true);


    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();
    fd.append("programType", "generateRandomQuestions");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", id);

    selectedSubject.forEach((subj) => fd.append("subject[]", subj));
    selectedChapter.forEach((chap) => fd.append("chapter[]", chap));
    selectedTopic.forEach((top) => fd.append("topic[]", top));
    selectedLevel.forEach((lvl) => fd.append("levelId[]", lvl));

    try {
      const response = await api.post("question/paperImport", fd);
      console.log("Random Questions Response:", response);

      if (response.data.status === true) {
        setQuestions(response?.data?.questions || []);
        setQuestionIds(response?.data?.questionIds || []);

        toast.success(
          `Successfully generated ${response?.data?.questions?.length || 0} questions`
        );
      }
      else {
        toast.error(response.data.message || "Failed to generate questions.");
      }

    } catch (error) {
      console.error("Error fetching questions:", error);
      toast.error("An error occurred while generating questions. Please try again.");
    }
    finally {
      setIsGenerating(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (questionIds.length === 0) {
      toast.warning("No questions to submit. Please generate questions first.");
      return;
    }


    setSubmitting(true);

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();
    fd.append("programType", "generateQuestionsFromQuestionIds");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", id);

    questionIds.forEach((id) => {
      fd.append(`questionIds[]`, id);
    });

    try {
      const response = await api.post("question/paperImport", fd);
      // console.log("Submitted Questions Response:", response);

      if (response.data.status === true) {
        toast.success(response.data.data);

        setTimeout(() => {
          setQuestions([]);
          setQuestionIds([]);
          setSelectedSubject([]);
          setSelectedChapter([]);
          setSelectedTopic([]);
          setSelectedLevel([]);
        }, 2000);
      }
    

    } catch (error) {
      console.error("Error submitting questions:", error);
      toast.error("An error occurred while submitting questions.");
    }
    finally {
      setSubmitting(false);
    }
  }

  const renderLatexText = (text) => {
    if (!text) return null;

    const decodedText = he.decode(text);
    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;

    decodedText.replace(
      latexAndImageRegex,
      (match, inlineLatex, blockLatex, quote, imageSrc, alignContent, index) => {
        if (index > lastIndex) {
          parts.push(decodedText.slice(lastIndex, index));
        }

        if (imageSrc) {
          parts.push(
            <img
              key={index}
              src={imageSrc}
              alt="Image"
              style={{
                maxWidth: "100%",
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px",
                maxHeight: "150px"
              }}
            />
          );
        } else if (alignContent) {
          parts.push(
            <BlockMath
              key={index}
              style={{
                display: "block",
                textAlign: "center",
                margin: "10px 0",
                whiteSpace: "pre-line",
                overflowX: "auto"
              }}
            >
              {`\\begin{align}${alignContent}\\end{align}`}
            </BlockMath>
          );
        } else if (inlineLatex || blockLatex) {
          parts.push(
            <InlineMath
              key={index}
              style={{
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px"
              }}
            >
              {inlineLatex || blockLatex}
            </InlineMath>
          );
        }

        lastIndex = index + match.length;
      }
    );

    if (lastIndex < decodedText.length) {
      parts.push(decodedText.slice(lastIndex));
    }

    return <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>;
  };

  const subjectOptions = subjects.map((subject) => ({
    value: subject.id,
    label: `${subject.subjectName} (${subject.subjectCount})`,
  }));

const chapterOptions = [
  { value: "all", label: "✅ Select All Chapters" },
  ...chapters.map((chapter) => ({
    value: chapter.id,
    label: `${chapter.chapterName} (${chapter.chapterCount})`,
  }))
];

 const topicOptions = [
  { value: "all", label: "✅ Select All Topics" },
  ...topics.map((topic) => ({
    value: topic.id,
    label: `${topic.topicName} (${topic.topicCount})`,
  }))
];

  const levelOptions = levels.map((level) => ({
    value: level.id,
    label: level.levelName.trim(),
  }));

  const handleSubjectChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map(opt => String(opt.value)) : [];
    setSelectedSubject(values);
  };

const handleChapterChange = (selectedOptions) => {
  if (!selectedOptions) {
    setSelectedChapter([]);
    return;
  }

  const values = selectedOptions.map(opt => opt.value);

  // ✅ If Select All clicked
  if (values.includes("all")) {
    const allChapterIds = chapters.map(ch => String(ch.id));
    setSelectedChapter(allChapterIds);
  } else {
    setSelectedChapter(values.map(String));
  }
};

  const handleTopicChange = (selectedOptions) => {
  if (!selectedOptions) {
    setSelectedTopic([]);
    return;
  }

  const values = selectedOptions.map(opt => opt.value);

  // ✅ If Select All clicked
  if (values.includes("all")) {
    const allTopicIds = topics.map(tp => String(tp.id));
    setSelectedTopic(allTopicIds);
  } else {
    setSelectedTopic(values.map(String));
  }
};

  const handleLevelChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map(opt => String(opt.value)) : [];
    setSelectedLevel(values);
  };

  const clearFilters = () => {
    setSelectedSubject([]);
    setSelectedChapter([]);
    setSelectedTopic([]);
    setSelectedLevel([]);
    setQuestions([]);
    setQuestionIds([]);
  };

  const canGenerate = selectedSubject.length > 0 && selectedChapter.length > 0 && selectedTopic.length > 0;

  // For Chapters
const isAllChaptersSelected = chapters.length > 0 && selectedChapter.length === chapters.length;

// For Topics
const isAllTopicsSelected = topics.length > 0 && selectedTopic.length === topics.length;

const customSelectStyles = {
  control: (base) => ({
    ...base,
    border: "1px solid #ddd",
    borderRadius: "8px",
    minHeight: "44px",
    boxShadow: "none",
    "&:hover": { borderColor: "#3498db" }
  }),
  valueContainer: (base) => ({
    ...base,
    maxHeight: "120px", // Increased height to show more tags
    overflowY: "auto",   // Enables the scrollbar
  }),
  // Keep this to hide the "Select All" tag itself from the input after clicking it
  multiValueRemove: (base, state) => {
    return state.data.value === 'all' ? { ...base, display: 'none' } : base;
  },
  menu: (base) => ({
    ...base,
    zIndex: 9999
  })
};

const handleReplaceQuestion = async (questionId, index) => {
  try {
    setReplacingId(questionId);

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();
    fd.append("programType", "replaceRandomQuestion");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", id);
    fd.append("questionId", questionId);

    selectedSubject.forEach((subj) => fd.append("subject[]", subj));
    selectedChapter.forEach((chap) => fd.append("chapter[]", chap));
    selectedTopic.forEach((top) => fd.append("topic[]", top));
    selectedLevel.forEach((lvl) => fd.append("levelId[]", lvl));

    const res = await api.post("/question/paperImport", fd);

    if (res?.data?.status) {
      const newQuestion = res.data.question;
      const oldQuestionId = res.data.replacedQuestionId;

      // 🔴 CHECK DUPLICATE
      const alreadyExists = questions.some(
        (q) => String(q.id) === String(newQuestion.id)
      );

      if (alreadyExists) {
        toast.error("⚠️ Same question already exists");
        return;
      }

      // ✅ REPLACE QUESTION IN UI
      setQuestions((prev) => {
        const updated = [...prev];
        updated[index] = newQuestion;
        return updated;
      });

      // ✅ UPDATE questionIds ARRAY
      setQuestionIds((prevIds) => {
        return prevIds.map((qid) =>
          String(qid) === String(oldQuestionId)
            ? String(newQuestion.id)
            : qid
        );
      });

      toast.success("✅ Question replaced successfully");
    } else {
      toast.error(res.data.message || "Failed to replace question");
    }

  } catch (err) {
    console.error(err);
    toast.error("Error replacing question");
  } finally {
    setReplacingId(null);
  }
};
  return (
    <div style={{
      padding: "24px",


      paddingBottom: questions.length > 0 ? "100px" : "24px",
      minHeight: "100vh"
    }}>


      {/* Header */}
      <div style={{ marginBottom: "32px" }}>
        <h2 style={{
          fontSize: "28px",
          fontWeight: "600",
          color: "#2c3e50",
          marginBottom: "8px"
        }}>
          Generate Random Questions
        </h2>
        <p style={{
          fontSize: "16px",
          color: "#7f8c8d",
          margin: "0"
        }}>
          Select filters below to generate questions for your paper
        </p>
      </div>



      {/* Filters Card */}
      <div style={{
        background: "white",
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        marginBottom: "32px"
      }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px"
        }}>
          <h3 style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#2c3e50",
            margin: "0"
          }}>
            Filter Questions
          </h3>
          <Button
          
            size="sm"
            onClick={clearFilters}
            disabled={!selectedSubject.length && !selectedChapter.length && !selectedTopic.length}
            style={{
              minWidth: "100px"
            }}
          >
            Clear All
          </Button>
        </div>

        {/* Filters Grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          marginBottom: "24px"
        }}>
          {/* Subject Filter */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              Subject <span style={{ color: "#e74c3c" }}>*</span>
            </label>
            <Select
              isMulti
              options={subjectOptions}
              value={subjectOptions.filter(opt => selectedSubject.includes(String(opt.value)))}
              onChange={handleSubjectChange}
              placeholder="Select subjects..."
              isSearchable
              styles={{
                control: (base) => ({
                  ...base,
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  minHeight: "44px",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#3498db"
                  }
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999
                })
              }}
            />
          </div>

          {/* Chapter Filter */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              Chapter <span style={{ color: "#e74c3c" }}>*</span>
            </label>
          {/* Chapter Filter */}
<Select
  isMulti
  options={chapterOptions}
  // Change: Filter the actual chapterOptions instead of showing the "all" summary
  value={chapterOptions.filter(opt => selectedChapter.includes(String(opt.value)))}
  onChange={handleChapterChange}
  placeholder="Select chapters..."
  isSearchable
  isDisabled={!selectedSubject.length}
  styles={customSelectStyles}
/>
          </div>

          {/* Topic Filter */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              Topic <span style={{ color: "#e74c3c" }}>*</span>
            </label>
           {/* Topic Filter */}
<Select
  isMulti
  options={topicOptions}
  // Change: Filter the actual topicOptions instead of showing the "all" summary
  value={topicOptions.filter(opt => selectedTopic.includes(String(opt.value)))}
  onChange={handleTopicChange}
  placeholder="Select topics..."
  isSearchable
  isDisabled={!selectedSubject.length || !selectedChapter.length}
  styles={customSelectStyles}
/>
          </div>

          {/* Level Filter */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              Difficulty Level
            </label>
            <Select
              isMulti
              options={levelOptions}
              value={levelOptions.filter(opt => selectedLevel.includes(String(opt.value)))}
              onChange={handleLevelChange}
              placeholder="Select levels (optional)..."
              isSearchable
              styles={{
                control: (base) => ({
                  ...base,
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  minHeight: "44px",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#3498db"
                  }
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999
                })
              }}
            />
          </div>
        </div>

        {/* Generate Button */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="primary"
            onClick={fetchRandomQuestions}
            disabled={!canGenerate || isGenerating}
             style={{
    background: "#0dcaf0",
    border: "none",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  }}
          >
            {isGenerating ? (
              <>
                <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                Generating...
              </>
            ) : (
              'Generate Questions'
            )}
          </Button>
        </div>
      </div>

      {/* Questions Section */}
      {questions.length > 0 && (
        <div style={{
          background: "white",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          overflow: "hidden"
        }}>
          {/* Questions Header */}
          <div style={{
            padding: "20px 24px",
            background: "#f8f9fa",
            borderBottom: "1px solid #e9ecef",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <h3 style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#2c3e50",
              margin: "0"
            }}>
              Generated Questions <span style={{ color: "#3498db", fontWeight: "500" }}>({questions.length})</span>
            </h3>
            <div>
              <Button
             
                onClick={fetchRandomQuestions}
                disabled={isGenerating}
                size="sm"
              >
                <i className="ph ph-arrows-clockwise" style={{ marginRight: "4px", }}></i> Regenerate
              </Button>
            </div>
          </div>

          {/* Questions List */}
          <div style={{ padding: "24px" }}>
            {questions.map((question, index) => (
              <div key={question.id} style={{
                background: "white",
                border: "1px solid #e9ecef",
                borderRadius: "8px",
                padding: "20px",
                marginBottom: "20px",
                transition: "box-shadow 0.2s",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                }
              }}>
                {/* Question Header */}
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "16px",
                  paddingBottom: "12px",
                  borderBottom: "1px solid #f1f2f3"
                }}>
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    <span style={{
                      background: "#e8f5e8",
                      color: "#27ae60",
                      padding: "4px 12px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      fontWeight: "500"
                    }}>
                      {question.levelName}
                    </span>
                    <span style={{
                      background: "#fee",
                      color: "#e74c3c",
                      padding: "4px 12px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      fontWeight: "500"
                    }}>
                      {question.examType}
                    </span>
                    <span style={{
                      background: "#fff3cd",
                      color: "#856404",
                      padding: "4px 12px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      fontWeight: "500"
                    }}>
                      ID: {question.id}
                    </span>
                  </div>
                 <div style={{
  display: "flex",
  alignItems: "center",
  gap: "10px"
}}>
    <button
  onClick={() => handleReplaceQuestion(question.id, index)}
  disabled={replacingId === question.id}
  style={{
    background: replacingId === question.id ? "#FFF3CD" : "#FFF3CD",
    border: "none",
    color: "#000",
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "500",
    cursor: replacingId === question.id ? "not-allowed" : "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    transition: "all 0.2s ease"
  }}
  onMouseEnter={(e) => {
    if (replacingId !== question.id) {
      e.target.style.background = "#d97706";
    }
  }}
  onMouseLeave={(e) => {
    if (replacingId !== question.id) {
      e.target.style.background = "#FFF3CD";
    }
  }}
>
  {replacingId === question.id ? (
    <>
      <span
        style={{
          width: "14px",
          height: "14px",
          border: "2px solid #fff",
          borderTop: "2px solid transparent",
          borderRadius: "50%",
          display: "inline-block",
          animation: "spin 0.6s linear infinite"
        }}
      />
      Replacing...
    </>
  ) : (
    "🔁 Replace"
  )}
</button>
  <span style={{
    fontSize: "14px",
    fontWeight: "600",
    color: "#7f8c8d"
  }}>
    Question {index + 1}
  </span>


</div>
                </div>

                {/* Question Content */}
                <div style={{ marginBottom: "20px" }}>
                  {renderLatexText(question.question)}
                </div>

                {/* Options or Answer Placeholder */}
                {question.options && question.options.length > 0 ? (
                  <>
                    <div style={{
                      fontWeight: "600",
                      marginBottom: "12px",
                      color: "#2c3e50"
                    }}>
                      Options:
                    </div>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: question.options.some(opt => opt.length > 50) ? "1fr" : "repeat(2, 1fr)",
                      gap: "12px"
                    }}>
                      {question.options.map((option, idx) => (
                        <div key={idx} style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "8px",
                          padding: "8px 12px",
                          background: "#f8f9fa",
                          borderRadius: "6px",
                          border: "1px solid #e9ecef"
                        }}>
                          <span style={{
                            fontWeight: "600",
                            color: "#3498db",
                            minWidth: "24px"
                          }}>
                            {String.fromCharCode(65 + idx)}.
                          </span>
                          <span style={{ flex: 1 }}>
                            {renderLatexText(option)}
                          </span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div style={{
                    padding: "16px",
                    background: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px dashed #dee2e6",
                    textAlign: "center",
                    color: "#6c757d",
                    fontWeight: "500",
                    fontSize: "16px"
                  }}>
                    Answer: _ _ _ _ _ _ _
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Fixed Bottom Button Bar */}
      {questions.length > 0 && (
        <div style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          background: "white",
          borderTop: "1px solid #e9ecef",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          padding: "16px 24px",
          zIndex: 1000
        }}>
          <div style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <div style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              {questions.length} question{questions.length !== 1 ? 's' : ''} selected
            </div>
            <div style={{ display: "flex", gap: "12px" }}>
              <Button
                variant="outline-secondary"
                onClick={clearFilters}
                style={{ minWidth: "100px" }}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                onClick={handleSubmit}
                disabled={submitting || questionIds.length === 0}
                style={{ minWidth: "140px", fontWeight: "600" }}
              >
                {submitting ? (
                  <>
                    <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                    Submitting...
                  </>
                ) : (
                  'Submit Questions'
                )}
              </Button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ marginTop: "70px" }}
      />
    </div>
  );
};

export default Random;